"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _constructor = _interopRequireDefault(require("../../../constants/constructor"));

/* istanbul ignore file */
class Route {
  /**
   * @param {Array<string>} methods
   * @param {Uri} uri
   */
  [_constructor.default](methods = [], uri) {
    this.methods = methods;
    this.uri = uri;
  }
  /**
   * @param {Array<string>} methods
   */


  setMethods(methods) {
    this.methods = methods;
    return this;
  }
  /**
   * @param {Array<string>} methods
   */


  addMethod(method) {
    this.methods.push(method);
    return this;
  }
  /**
   * @return {Array<string>}
   */


  getMethods() {
    return this.methods;
  }
  /**
   * @param {Uri} uri
   */


  setUri(uri) {
    this.uri = uri;
    return this;
  }
  /**
   * @return {Uri}
   */


  getUri() {
    return this.uri;
  }

}

exports.default = Route;